<template>
  <v-app>
    <div class="loader-center" v-if="isAccountsFetchWaiting">
      <span class="app-loader__message">Loading all accounts...</span>
      <v-progress-circular
        class="mx-auto"
        :size="70"
        :width="7"
        indeterminate
      ></v-progress-circular>
    </div>
    <template v-else>
      <v-main>
        <v-container fluid>
          <v-container class="pa-1">
            <v-item-group v-model="selected">
              <v-row>
                <v-col
                  v-for="(account, i) in resellerAccountList"
                  :key="i"
                  cols="6"
                  md="6"
                >
                  <v-item>
                    <v-card
                      class="align-center"
                      height="120"
                      color="#e8edfc"
                      @click="selectAccount(account.id, 'reseller')"
                    >
                      <div class="account-info text-center">
                        <v-avatar color="rgb(188,188,255)">
                          <span class="primary--text">{{
                            account.code.substr(0, 2).toUpperCase()
                          }}</span>
                        </v-avatar>
                        <div class="display-1">{{ account.code }}</div>
                      </div>
                    </v-card>
                  </v-item>
                </v-col>
              </v-row>
            </v-item-group>

            <v-item-group v-model="selected">
              <v-row>
                <v-col
                  v-for="(account, i) in wlAccountList"
                  :key="i"
                  cols="6"
                  md="6"
                >
                  <v-item>
                    <v-card
                      class="align-center"
                      height="120"
                      @click="selectAccount(account.id, 'whitelabel')"
                    >
                      <div class="account-info text-center">
                        <v-avatar color="rgb(188,188,255)">
                          <span class="primary--text">{{
                            account.code.substr(0, 2).toUpperCase()
                          }}</span>
                        </v-avatar>
                        <div class="display-1">{{ account.code }}</div>
                      </div>
                    </v-card>
                  </v-item>
                </v-col>
              </v-row>
            </v-item-group>
          </v-container>
        </v-container>
      </v-main>
    </template>
  </v-app>
</template>
<script>
import { mapActions, mapGetters } from "vuex";
export default {
  data() {
    return {
      selected: null,
    };
  },
  computed: {
    ...mapGetters({
      isLoggedIn: "user/isLoggedIn",
      accountsFetchError: "partner/fetchError",
      isAccountsFetchWaiting: "partner/isFetchWaiting",
      resellerAccountList: "partner/resellerAccountList",
      wlAccountList: "partner/wlAccountList",
    }),
  },
  methods: {
    ...mapActions({
      setActiveAccount: "partner/setActiveAccount",
      clearAllBusinesses: "business/clearAllBusinesses",
    }),
    selectAccount(accountId, accountType) {
      this.setActiveAccount({
        accountId: accountId,
        accountType: accountType,
      });
      this.clearAllBusinesses();
      this.$router.push("/partner/home");
    },
  },
};
</script>

<style>
.home {
  min-height: 100%;
}

.centered-content {
  display: flex;
  justify-content: center;
  flex-direction: column;
  text-align: center;
}

.account-info {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: space-around;
}
</style>
